// removed by extract-text-webpack-plugin
module.exports = {"layoutWrapperMain":"PasswordResetPage__layoutWrapperMain__-LXfb","root":"PasswordResetPage__root__2k3jV","content":"PasswordResetPage__content__3U-5U","form":"PasswordResetPage__form__1gVKc","error":"PasswordResetPage__error__3J26I","modalTitle":"PasswordResetPage__modalTitle__2kDI7","modalMessage":"PasswordResetPage__modalMessage__Ucaeo","email":"PasswordResetPage__email__DQc2j","helperLink":"PasswordResetPage__helperLink__3xGFs","helperText":"PasswordResetPage__helperText__1U4S8","submitButton":"PasswordResetPage__submitButton__2GRIe","modalIcon":"PasswordResetPage__modalIcon__3FppW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PasswordResetPage/PasswordResetPage.css
// module id = 2355
// module chunks = 0